import { useMemo } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { useSelector, shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import PageHead from "@/components/PageHead";
import { getSarwaText } from "../../../locales/sarwa";

// Reserve space while Sarwa loads to reduce CLS + keep page responsive
const Sarwa = dynamic(() => import("@/components/Sarwa/Sarwa"), {
  ssr: false,
  loading: () => (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ height: { xs: 320, md: 460 }, width: "100%" }} />
    </Box>
  ),
});

export default function SarwaLife() {
  const mainTab = useSelector((state) => state.mainTab.mainTab, shallowEqual);
  const { t, locale } = useI18n();
  const sarwaText = getSarwaText(locale);

  const translation = useMemo(() => {
    const isCompanies = mainTab === "شركات";
    return isCompanies
      ? sarwaText.sarwa.sarwa_insurance_companies
      : sarwaText.sarwa.sarwa_insurance_individual;
  }, [mainTab, sarwaText]);

  return (
    <>
      <PageHead
        title={t.pages_main_tags.sarwaInsurance.title}
        description={t.pages_main_tags.sarwaInsurance.meta_desc}
      />

      <Box
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{ bgcolor: "#f2f2f2", position: "relative" }}
      >
       
        <Sarwa
          logo={translation.logo}
          title={translation.title}
          hyperlink={translation.hyperlink}
          paragraph={translation.paragraph}
          list_title={translation.list_title}
          list={translation.list}
          for_details={translation.for_details}
          link={translation.link}
          img={translation.img}
          sub_title={translation.sub_title}
        />
      </Box>
    </>
  );
}
